var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNavigateBefore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    viewBox: "0 96 960 960",
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M560.41 802.153 333.847 575.59 560.41 348.77l35.794 35.794L405.435 575.59l190.769 190.769-35.794 35.794Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavigateBefore);
export default __webpack_public_path__ + "static/media/icon-navigate-before.5501e31f9da41f6f498d9dac4bdcb882.svg";
export { ForwardRef as ReactComponent };